"use client";

import { c as _c } from "react/compiler-runtime";
import { X } from "@untitledui/icons";
import { useEffect } from "react";
import { cx } from "@/utils/cx";
export interface Toast {
  id: string;
  message: string;
  type: "success" | "error";
  duration?: number;
  undo?: () => void;
}
interface ToastProps {
  toast: Toast;
  onDismiss: (id: string) => void;
}
export function Toast(t0) {
  const $ = _c(30);
  const {
    toast,
    onDismiss
  } = t0;
  let t1;
  let t2;
  if ($[0] !== onDismiss || $[1] !== toast.duration || $[2] !== toast.id) {
    t1 = () => {
      if (toast.duration && toast.duration > 0) {
        const timer = setTimeout(() => {
          onDismiss(toast.id);
        }, toast.duration);
        return () => clearTimeout(timer);
      }
    };
    t2 = [toast.id, toast.duration, onDismiss];
    $[0] = onDismiss;
    $[1] = toast.duration;
    $[2] = toast.id;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== onDismiss || $[6] !== toast) {
    const colors = toast.type === "success" ? {
      bg: "bg-utility-success-50",
      text: "text-utility-success-700",
      border: "ring-utility-success-200"
    } : {
      bg: "bg-utility-error-50",
      text: "text-utility-error-700",
      border: "ring-utility-error-200"
    };
    t7 = cx("flex items-start gap-3 rounded-lg p-4 shadow-lg ring-1", colors.bg, colors.border, "max-w-[400px] min-w-[300px]");
    t8 = "alert";
    t9 = <p className={cx("flex-1 text-sm", colors.text)}>{toast.message}</p>;
    t5 = "flex items-center gap-2";
    t6 = toast.undo && <button onClick={() => {
      toast.undo?.();
      onDismiss(toast.id);
    }} className={cx("text-sm font-semibold underline", colors.text)}>Undo</button>;
    if ($[14] !== onDismiss || $[15] !== toast.id) {
      t3 = () => onDismiss(toast.id);
      $[14] = onDismiss;
      $[15] = toast.id;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    t4 = cx("shrink-0 rounded p-1 transition-colors", "hover:bg-black/5 focus:outline-2 focus:outline-offset-2 focus:outline-focus-ring", colors.text);
    $[5] = onDismiss;
    $[6] = toast;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <X className="size-4" data-icon={true} />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t3 || $[19] !== t4) {
    t11 = <button onClick={t3} className={t4} aria-label="Dismiss">{t10}</button>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t5 || $[23] !== t6) {
    t12 = <div className={t5}>{t6}{t11}</div>;
    $[21] = t11;
    $[22] = t5;
    $[23] = t6;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t13 = <div className={t7} role={t8}>{t9}{t12}</div>;
    $[25] = t12;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}